export default __webpack_public_path__ + "static/PromptIconNine-ced366dac41f7ae294ca9f37ba95659e.png";